import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/content-site/components/page";
import { loadContentPage, contentHead } from "@/content-site/lib/page";
export const Route = createFileRoute("/_content/docs/api/reference/")({
  loader: () => loadContentPage(["docs", "api", "reference"]),
  head: ({ loaderData }) => contentHead(loaderData),
  component: Page,
});
function Page() {
  return <ContentPage data={Route.useLoaderData()} />;
}
